import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import PackageCard from "../components/PackageCard";
import { Heart } from "lucide-react";
import LeadForm from "../components/LeadForm";
import Seo from "../components/Seo";

const HERO = "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=1920&q=80";

export default function Honeymoon() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/packages").then(r => setItems(r.data.filter(p => ["Maldives", "Bali", "Mauritius", "Thailand", "Europe", "Andaman"].includes(p.destination)).slice(0, 8))); }, []);
  return (
    <div className="pt-16 lg:pt-20">
      <Seo title="Honeymoon Packages" path="/honeymoon" description="Curated honeymoon packages for Maldives, Bali, Mauritius, Thailand and Europe — overwater villas, private beaches, sunset dinners. Fully customized." />
      <div className="relative h-[60vh] overflow-hidden">
        <img src={HERO} alt="Honeymoon" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20" />
        <div className="container-p relative h-full flex flex-col justify-end pb-12 z-10 text-white">
          <Heart className="w-8 h-8 text-[#FF7D00] mb-3" />
          <h1 className="h1 text-white max-w-3xl">Honeymoon Packages</h1>
          <p className="text-white/85 mt-3 max-w-2xl">Curated romantic escapes — overwater villas, private beaches, sunset dinners. We handle every detail so you can just be together.</p>
        </div>
      </div>

      <section className="section container-p">
        <span className="section-label">Featured Honeymoons</span>
        <h2 className="h2 mt-2 mb-10">Romance, curated</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">{items.map(p => <PackageCard key={p.id} p={p} />)}</div>
      </section>

      <section className="container-p pb-20"><div className="card-glass p-8 md:p-12"><LeadForm title="Plan Your Honeymoon" source="honeymoon" /></div></section>
    </div>
  );
}
